import { render, staticRenderFns } from "./KeySubInfos.vue?vue&type=template&id=66d61134&scoped=true&"
import script from "./KeySubInfos.vue?vue&type=script&setup=true&lang=js&"
export * from "./KeySubInfos.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./KeySubInfos.vue?vue&type=style&index=0&id=66d61134&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d61134",
  null
  
)

export default component.exports